// 上传图片
export const uploadImage = function (data) {
  return this.$http('post', 'common/anonymous/oss/upload', data);
}

// 批量埋点
export const addBuryingPoint = function (data = {}) {
  return this.$http('post', 'mall/klXpAction/add', {
    ...data,
    requestSource: 'WEB'
  });
}
// 批量埋点
export const addBatchBuryingPoint = function (data=[]) {
  return this.$http('post', 'mall/klXpAction/addBatch', data.map(item => ({
    ...item,
    requestSource: 'WEB'
  })));
}
